import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatApiErrorDetail } from "@/lib/errors";
import { Loader2, Lock, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { toast.error("Au moins 8 caractères."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      toast.success("Mot de passe mis à jour. Connectez-vous.");
      setTimeout(() => navigate("/login"), 1500);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid="reset-password-page">
      <div className="w-full max-w-md">
        <Link to="/login" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground mb-6">
          <ArrowLeft className="w-4 h-4" /> Retour à la connexion
        </Link>
        <div className="w-11 h-11 rounded-2xl bg-primary/10 flex items-center justify-center mb-4"><Lock className="w-6 h-6 text-primary" /></div>
        <h1 className="font-heading text-2xl font-bold tracking-tight">Nouveau mot de passe</h1>
        {!token ? (
          <p className="text-sm text-muted-foreground mt-2" data-testid="reset-no-token">Lien invalide. Refaites une demande depuis la page de connexion.</p>
        ) : done ? (
          <p className="text-sm text-muted-foreground mt-2">Mot de passe mis à jour. Redirection…</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div className="space-y-1.5">
              <Label>Mot de passe (min. 8 caractères)</Label>
              <Input data-testid="reset-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required />
            </div>
            <Button type="submit" disabled={loading || password.length < 8} data-testid="reset-submit-btn" className="w-full h-11 rounded-xl font-semibold">
              {loading ? <Loader2 className="w-4 h-4 klt-spin" /> : "Réinitialiser mon mot de passe"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
